import i18next from 'i18next';

export const checkIsNotNegativeNumber = (_: unknown, value: string) => {
  const valueNum = Number(value);

  if (Number.isNaN(valueNum)) {
    return Promise.reject(
      new Error(i18next?.t('Validation.ShouldBeNumber', 'Should be number')),
    );
  }

  if (valueNum < 0) {
    return Promise.reject(
      new Error(
        i18next?.t(
          'Validation.CantBeNegativeNumber',
          "Number can't be negative",
        ),
      ),
    );
  }

  return Promise.resolve();
};
export const checkIsPositiveNumber = (_: unknown, value: string) => {
  const valueNum = Number(value);

  if (Number.isNaN(valueNum)) {
    return Promise.reject(
      new Error(i18next?.t('Validation.ShouldBeNumber', 'Should be number')),
    );
  }

  if (valueNum <= 0) {
    return Promise.reject(
      new Error(
        i18next?.t('Validation.ShouldBePositive', 'Should be positive number'),
      ),
    );
  }

  return Promise.resolve();
};
